import { PropsWithChildren } from 'react';

import {
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from '@/components/ui/accordion';
import { cn } from '@/utils/cn';

import { BenefitIcon } from '../benefit-icon';

type Props = PropsWithChildren & {
    id: string;
    isSelected: boolean;
    title: string;
};

export const DevelopmentAccordionItem = ({
    children,
    id,
    isSelected,
    title,
}: Props) => (
    <AccordionItem
        value={id}
        className={cn(
            `
              border px-6 transition-all duration-300 ease-in-out

              sm:px-10
            `,
            isSelected ? 'rounded-[60px] py-6' : 'rounded-[40px] py-1',
        )}
    >
        <AccordionTrigger disablePlusButton>
            <div
                className={`
                  typography-h7 flex items-center gap-5

                  lg:typography-h6
                `}
            >
                <BenefitIcon />
                {title}
            </div>
        </AccordionTrigger>
        <AccordionContent>{children}</AccordionContent>
    </AccordionItem>
);
